export default "__VITE_ASSET__gfVheH_H__"